getUserContactDataEmarsys